// Shared page shell for screens outside the editor: slim top bar with the
// logo, current section and a sign-out control. The editor uses the
// bottom-left Account menu instead (same actions) so switching never feels
// like another app.

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function TopBar({ section }: { section?: string }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const signOut = async () => {
    await logout();
    nav('/', { replace: true });
  };

  return (
    <header className="topbar" role="banner">
      <span className="topbar-logo">
        <span className="logo-dot" aria-hidden="true" />
        ColorSep
      </span>
      {section ? <span className="topbar-section">{section}</span> : null}
      <div className="topbar-spacer" />
      {user ? (
        <div className="user-menu">
          <span className="avatar" aria-hidden="true" title={user.username}>
            {user.username[0]?.toUpperCase() ?? '?'}
          </span>
          <span className="dim">{user.username}</span>
          <button className="topbar-link as-btn" onClick={signOut}>
            Sign out
          </button>
        </div>
      ) : null}
    </header>
  );
}
